import { type CollapseProps } from 'antd/es/collapse';

export const faqItems: CollapseProps['items'] = [
  {
    key: '1',
    label: <p className="faq-question">What is the Inpay API?</p>,
    children: (
      <p>
        The Inpay API (Application Programming Interface) is a way to access the
        Inpay services through communicating with our servers from your own
        software. It allows for cross-border payments solutions to be arranged
        easily – Inpay’s backend systems will manage all the regulatory rules
        and the different technologies and languages involved.
      </p>
    )
  },
  {
    key: '2',
    label: (
      <p className="faq-question">Who can benefit from using the Inpay API?</p>
    ),
    children: (
      <p>
        Inpay directs its services toward selected sectors, including
        <b> Financial Services, iGaming, and NGOs</b> who need to make
        cross-border payments or collections. These are sectors with high
        demands and who value such as transparency, compliance, simple cost
        structure, and a simple integration with human support. <br />
        Connecting via the Inpay API allows for seamless integration with
        Inpay's services, and utilizing the API is particularly valuable when
        having many transactions or a wish to automate the flow.
      </p>
    )
  },
  {
    key: '3',
    label: (
      <p className="faq-question">Is the Inpay API available to everybody?</p>
    ),
    children: (
      <p>
        If you find that our services may suit your needs, please{' '}
        <a target="_blank" href="www.inpay.com/contact-us">
          contact us
        </a>{' '}
        and we will help you find out how we might be able to service you. Our
        sales team is easily available through{' '}
        <a target="_blank" href="www.inpay.com/contact-us">
          this contact form.
        </a>
      </p>
    )
  },
  {
    key: '4',
    label: <p className="faq-question">Is the Inpay API free to use?</p>,
    children: (
      <p>
        Inpay provides professional services with a simple cost structure, and
        customers with a need for conducting cross-border payments might well
        find it worthwhile using our services to reduce the complexity of
        arranging these – through the API or the Customer App. The Inpay API is
        not for free and not useful on its own, but it is a valuable way of
        benefiting from the services.
      </p>
    )
  },
  {
    key: '5',
    label: <p className="faq-question">How can we get started with the API?</p>,
    children: (
      <p>
        To have a talk with us about your needs, please just reach out to our
        sales team who will be happy to help. You can most conveniently use this{' '}
        <a target="_blank" href="www.inpay.com/contact-us">
          contact form.
        </a>
      </p>
    )
  },
  {
    key: '6',
    label: (
      <p className="faq-question">
        How can we integrate the Inpay API with our in-house system?
      </p>
    ),
    children: (
      <p>
        The Inpay API is based on a standard REST method for easy communication,
        and this can be implemented through many different programming
        languages. If your in-house system allows you to get access the input
        data for the API endpoints as well as sending back the output back to
        the system, then you already have the basics in place.{' '}
        <a href="/docs/guide/getting-started" target="_blank">
          Please see our guidelines in this documentation for more information
          on how to get started.
        </a>
      </p>
    )
  },
  {
    key: '7',
    label: (
      <p className="faq-question">
        Which skills are needed to integrate the Inpay API?
      </p>
    ),
    children: (
      <p>
        You will need to have skills in programming and at least a basic
        understanding of data communication and APIs as well as{' '}
        <a
          href="/docs/guide/docs-integration#integration-webhooks"
          target="_blank"
        >
          setting up webhook URLs
        </a>{' '}
        to use from your software. Experience in programming against a REST API
        or similar experience with programming for communication and depending
        on the complexity of your solution you might need good skills in
        structuring and developing asynchronous software. Knowledge about
        working with end-to-end encryption is an advantage. You will also need
        access to communicate with your in-house systems and skills in utilizing
        this.
      </p>
    )
  },
  {
    key: '8',
    label: (
      <p className="faq-question">Which technologies are used with the API?</p>
    ),
    children: (
      <p>
        On your side of the integration, almost any programming language can be
        used. For the webhooks, you will need a web server that can be made
        accessible through the Internet. <br /> The Inpay API uses REST,
        webhooks, and some areas utilize a set of Inpay-hosted user-directed
        user interface elements (input forms) that will work in most web
        browsers without requiring any technology at your site. <br />{' '}
        Authentication and encryption are provided through S-MIME (PKI) with
        HTTPS/TLS and Authentication Bearer Tokens.
      </p>
    )
  },
  {
    key: '9',
    label: (
      <p className="faq-question">
        Which programming languages are recommended for the integration?
      </p>
    ),
    children: (
      <p>
        Most programming languages can be used. Our customers use a wide
        selection of PHP, Java, Go, Ruby, Node.js, often with libraries or
        frameworks such as Guzzle, Symphony, or Faraday. But you are not limited
        to this selection. If your developers prefer something else or your
        existing solutions are developed in a different language, you might want
        to check how well this will work with the technology stack.
      </p>
    )
  },
  {
    key: '10',
    label: (
      <p className="faq-question">
        Are there any capacity limitations for the API?
      </p>
    ),
    children: (
      <p>
        Yes, there is a limitation of <code>50</code> transactions per{' '}
        <code>10</code> minutes for payment requests and authorization requests.
        This counts separately for each <code>HTTP_X_AUTH_UUID</code>. This
        should fit the needs with most implementations of integration solutions,
        but you might want to ensure that your solution isn’t trying to exceed
        this number at any time.
      </p>
    )
  },
  {
    key: '11',
    label: (
      <p className="faq-question">
        I am not a technical person – how can I learn about the Inpay services?
      </p>
    ),
    children: (
      <p>
        Depending on your needs and knowledge, you might want to start with the{' '}
        <a href="/docs/guide/overview" target="_blank">
          Introduction section
        </a>{' '}
        of this documentation and then browse through some of the other
        sections, based on your interests – or you could benefit more from
        letting our sales teams guide you.
      </p>
    )
  },
  {
    key: '12',
    label: (
      <p className="faq-question">
        I am a programmer – what is the minimum I must learn to get started with
        the API?
      </p>
    ),
    children: (
      <p>
        If you already have some knowledge of APIs and how to develop against
        them, we suggest that you walk through this documentation from the{' '}
        <a href="/docs/reference/getting-started#introduction" target="_blank">
          Introduction
        </a>
        ,{' '}
        <a
          href="/docs/guide/about#integration-process-about-api-capabilities"
          target="_blank"
        >
          About
        </a>{' '}
        and{' '}
        <a href="/docs/reference/getting-started" target="_blank">
          Getting Started
        </a>{' '}
        sections, as these contain details specific for the Inpay API and the
        onboarding process that you need to know. Next step is then{' '}
        <a
          href="/docs/guide/docs-integration#integration-definitions"
          target="_blank"
        >
          Basic concepts
        </a>{' '}
        and{' '}
        <a href="/docs/guide/integration-process" target="_blank">
          Integration process
        </a>
        . <br /> That should equip you with all you need to learn to get
        started. Our Onboarding & Support department will additionally guide you
        along the way.
      </p>
    )
  },
  {
    key: '13',
    label: (
      <p className="faq-question">
        Do you have a recommended process to follow for an integration project?
      </p>
    ),
    children: (
      <p>
        Yes, we have our onboarding process, described in the{' '}
        <a href="/docs/guide/getting-started" target="_blank">
          Getting Started
        </a>{' '}
        section, that you will go through together with our Onboarding & Support
        team, and we have suggested a process in the{' '}
        <a href="/docs/guide/integration-process" target="_blank">
          Integration Process
        </a>{' '}
        section for your development project. You do not have to follow this
        process strictly, but there are some necessary elements, and they need
        to be aligned with the onboarding process – so we strongly advise you to
        read through the description of the suggested process and ensure that
        you incorporate all details in your own process.
      </p>
    )
  },
  {
    key: '14',
    label: (
      <p className="faq-question">
        Where can I see the prerequisites for getting started with the API?
      </p>
    ),
    children: (
      <p>
        Process-wise, the{' '}
        <a href="/docs/guide/getting-started" target="_blank">
          Getting Started
        </a>{' '}
        section will show you the steps to include in your overall project plan,
        and technically, the Basic concepts section will explain the details you
        need to know.
      </p>
    )
  },
  {
    key: '15',
    label: (
      <p className="faq-question">
        Are the examples in the documentation plug-and-play?
      </p>
    ),
    children: (
      <p>
        They are, as far as this can be done. Because the API documentation with
        its examples is customized to your needs, you will find a precise
        description of required fields in connection with the examples, and the
        examples themselves will contain these. You will, however, need to fill
        out or adjust the actual values to be meaningful for your use. The
        examples will often illustrate some of the optional fields as well. The
        examples show unencrypted payloads only,{' '}
        <b>so you will have to make sure to encrypt payloads.</b>
      </p>
    )
  },
  {
    key: '16',
    label: (
      <p className="faq-question">
        The reference section is customized – what does that mean?
      </p>
    ),
    children: (
      <p>
        It means that you see only the relevant information for your enabled
        products regarding endpoints, parameter fields, and examples,
        highlighting the mandatory fields for exactly your situation. Mandatory
        fields vary between customers and their selected products, so this
        pre-selection of content will minimize the risk of mistakes and make
        your integration process much easier.
      </p>
    )
  },
  {
    key: '17',
    label: (
      <p className="faq-question">
        The documentation is incomplete or inaccurate, what do I do?
      </p>
    ),
    children: (
      <p>
        You are always welcome to contact us at{' '}
        <a href="mailto:support@inpay.com">support@inpay.com</a>, and we will
        get it fixed as soon as possible. <br /> If you have found areas where
        you are not sure if it is correct or not, the same applies – contact us
        and we will investigate and get back to you. And if you just have
        suggestions for improvements, feel free to contact your Account Manager.
      </p>
    )
  },
  {
    key: '18',
    label: (
      <p className="faq-question">How often is the documentation updated?</p>
    ),
    children: (
      <p>
        The documentation is updated continuously, and a new version will be
        published immediately when new features are added or current features
        are changed.
      </p>
    )
  },
  {
    key: '19',
    label: (
      <p className="faq-question">
        Do you provide sandboxes for testing our integration?
      </p>
    ),
    children: (
      <p>
        Yes, we provide sandboxes for testing your integration solution against,
        and they are configured in the same way as the production environments
        to allow you to make an exact test and configuration match. The
        sandboxes can be accessed through the same endpoints as the production
        environments, just with your testing credentials.{' '}
        <a
          href="/docs/guide/getting-started#getting-started-environments-and-going-live"
          target="_blank"
        >
          You can read more about this here
        </a>
      </p>
    )
  },
  {
    key: '20',
    label: (
      <p className="faq-question">Is there a test environment available?</p>
    ),
    children: (
      <p>
        Yes, your testing environment will be available in a separate space on
        the Inpay servers, completely separated from the production environment.
        <br />
        It is accessible through the same URLs as the production environment and
        with the same functionality, just with your testing credentials and the
        testing server name.
      </p>
    )
  },
  {
    key: '21',
    label: (
      <p className="faq-question">
        How can I get started with the sandbox environment?
      </p>
    ),
    children: (
      <p>
        When you are ready for testing, we suggest you get in contact with the
        Onboarding & Support team to ensure that you follow the correct steps.
        As a minimum, you need to get your testing credentials set up and then
        follow the guidelines in the Getting Started section of this
        documentation.{' '}
        <a
          href="/docs/guide/getting-started#getting-started-onboarding"
          target="_blank"
        >
          Read more about this here
        </a>
      </p>
    )
  },
  {
    key: '22',
    label: (
      <p className="faq-question">
        How do we get support if we run into problems with the integration?
      </p>
    ),
    children: (
      <p>
        Our dedicated Onboarding & Support team is ready to assist you if you
        need help. Just contact us at{' '}
        <a href="mailto:support@inpay.com">support@inpay.com</a>, and we will
        get back to you.
      </p>
    )
  }
];
